import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GenericBaseComponent } from 'app/shared/components/base/generic-base/generic-base.component';
import { Permissions } from 'app/shared/constants/permissions';
import { Sections } from 'app/shared/constants/sections';
import { PaymentRequestDetail } from 'app/shared/models/payment-request-detail.model';
import { PaymentRequestService } from 'app/shared/services/payment-request.service';
import { SectionService } from 'app/shared/services/section.service';
import { Modules } from 'app/shared/constants/modules';

@Component({
  selector: 'app-payment-request-information',
  templateUrl: './payment-request-information.component.html',
  styleUrls: ['./payment-request-information.component.scss']
})

export class PaymentRequestInformationComponent extends GenericBaseComponent implements OnInit {

  @Input() currentObjectId: number;
  @Output() afterSubmitEvent = new EventEmitter<object>();

  currentObject: PaymentRequestDetail;

  get paymentRequestmoduleId(): number {
    return Modules.PaymentRequests_Code;
  }

  get hasAuditTrailViewPermission(): boolean {
    return this.hasPermission(Permissions.PaymentRequestInformation_AuditTrail_View);
  }

  get hasFinancialTransactionsViewPermission(): boolean {
    return this.hasPermission(Permissions.PaymentRequestInformation_FinancialTransactions_View);
  }

  constructor(public paymentRequestService: PaymentRequestService, protected sectionService: SectionService, public activeModal: NgbActiveModal) {
    super(sectionService, Sections.PaymentRequestInformation);
  }

  ngOnInit() {
    super.initialize();
  }

  closeModal() {
    this.activeModal.close();
    this.afterSubmitEvent.emit();
  }
}
